import { HStack, Stack, Image, Text, VStack, useColorMode, Box } from '@chakra-ui/react'
import React from 'react'
import { motion } from 'framer-motion'
import { FiCalendar, FiPercent } from 'react-icons/fi'
import { getTokens } from '../../config/colorTokens'

const MotionBox = motion(Box)

const EducationItem = (props) => {
	const { colorMode } = useColorMode()
	const t = getTokens(colorMode)

	return (
		<MotionBox
			variants={props.variants}
			whileHover={{
				scale: 1.02,
				transition: { type: 'spring', stiffness: 300, damping: 20 }
			}}>
			<Stack
				direction={{ base: 'row', md: 'row' }}
				border="1px"
				borderRadius="10px"
				borderColor={t.borderCard}
				backdropFilter={'blur(5px)'}
				width="100%"
				p={4}>
				<Image
					mt={1}
					style={{ height: '60px', width: '60px' }}
					borderRadius="10px"
					src={props.logo}
				/>
				<VStack alignItems="left" spacing={0} p={0}>
					<Text fontSize="md" fontWeight="bold">
						{props.name}
					</Text>
					<Text fontSize="sm" fontWeight="semibold">
						{props.degree} · {props.stream}
					</Text>
					<Text color={t.textMuted} display="flex" alignItems="center" fontSize="sm">
						<FiCalendar />
						&nbsp;{props.date}
					</Text>
					<Text color={t.textMuted} fontSize="sm" display="flex" alignItems="center">
						<FiPercent />
						&nbsp;Grade: {props.grade}
					</Text>
				</VStack>
			</Stack>
		</MotionBox>
	)
}

export default EducationItem